import type { LvCheckCode } from '../api/calculation-lv.api'

/** Die Befunde der Prüfliste, in der Reihenfolge der Anzeige; Eventual ohne Preis ist nur ein Hinweis. */
export const PRUEFUNG: Record<LvCheckCode, { titel: string; hinweis?: boolean }> = {
  GAP_TOO_LONG: { titel: 'Stichwortlücke länger als 10 Zeichen' },
  GAP_REQUIRED_OPEN: { titel: 'Pflicht-Bieterlücke offen' },
  GAP_OPEN: { titel: 'Bieterlücke offen' },
  GAP_OPTIONAL_OPEN: { titel: 'Bieterlücke offen (freiwillig)', hinweis: true },
  PRICE_MISSING: { titel: 'ohne Preis' },
  PRICE_MISSING_OPTIONAL: { titel: 'Eventual- oder Wahlposition ohne Preis', hinweis: true },
  UNIT_UNTRANSLATED: { titel: 'Einheit ohne Übersetzung' },
  SURCHARGE_PERCENT_MISSING: { titel: 'Zuschlag ohne Prozent' },
  PRICE_SPLIT_MISSING: { titel: 'Lohn/Sonstiges gefordert, aber EP von Hand ohne Blatt — nicht aufteilbar' },
  MANUAL_DEVIATION: { titel: 'EP von Hand weicht ab' },
}
